import * as Contacts from 'expo-contacts';
import { useCallback, useState } from 'react';
import { useComponentFocus } from './use-component-focus';

export const useContacts = () => {
  const [contacts, setContacts] = useState<Contacts.Contact[] | null>(null);
  const [permissionStatus, setPermissionStatus] =
    useState<Contacts.PermissionStatus | null>(null);
  const [canShowDeniedAlert, setCanShowDeniedAlert] = useState(false);

  useComponentFocus({
    initialFocus: true,
    onFocus: useCallback(async () => {
      const {
        status: getStatus,
        canAskAgain,
        granted,
      } = await Contacts.getPermissionsAsync();
      let status = getStatus;

      if (!canAskAgain && !granted) {
        setCanShowDeniedAlert(true);
        setPermissionStatus(getStatus);
        return;
      } else if (getStatus !== Contacts.PermissionStatus.GRANTED) {
        const { status: requestStatus } =
          await Contacts.requestPermissionsAsync();
        status = requestStatus;
      }
      setPermissionStatus(status);

      if (status === Contacts.PermissionStatus.GRANTED) {
        const { data } = await Contacts.getContactsAsync({
          fields: [
            Contacts.Fields.Name,
            Contacts.Fields.PhoneNumbers,
            Contacts.Fields.Emails,
          ],
          sort: Contacts.SortTypes.UserDefault,
        });

        setContacts(data);
      }
    }, []),
  });

  return {
    canShowDeniedAlert,
    contacts,
    permissionStatus,
  };
};
